import React, { Component } from "react";
import AboutWrapper from "./AboutWrapper";
import Breadcrumb from "./Breadcrumb";
import LayoutHeader from "../../common/LayoutHeader";
import Footer from "../../common/LayoutFooter";

class About extends Component {
  render() {
    return (
      <div className="hypena-page-wrap">
        <LayoutHeader activate="about" />
        <Breadcrumb />
        <AboutWrapper />
        <Footer />
      </div>
    );
  }
}

export default About;
